function Erro(){
    return(
        <div className="global-pageContainer-left">
            <h1>404</h1>
            <h2>Página não encontrada</h2>
            <a href="/">Home</a>
        </div>
    )
}

export default Erro;